import React from 'react';

export const themes = {
    theme: 'dark',
};

export const ThemeContext = React.createContext();
